import {useTranslation} from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import {Route, Routes} from "react-router-dom";
import React from "react";
import {useHasScope} from "../../../config/globalConfig";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";
import {SCOPE_FINANCE_REGISTRY_FUEL_CARD} from "./cardfuel/constants/RegistryFuelCardAuth";
import RegistryFuelCards from "./cardfuel/sections/RegistryFuelCards";
import RegistryFuelCard from "./cardfuel/sections/RegistryFuelCard";

const PageRegistryFuelCards = () => {
    const {t} = useTranslation('finance', {keyPrefix: 'registryFuelCard'});
    const hasScope = useHasScope;

    return (
        hasScope(SCOPE_FINANCE_REGISTRY_FUEL_CARD) ?
            <Routes>
                <Route path="/" element={
                    <>
                        <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                        <RegistryFuelCards/>
                    </>
                }/>
                <Route path="/add" element={
                    <>
                        <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                        <RegistryFuelCard/>
                    </>
                }/>
            </Routes>
        : <NotAuthorizedDialog/>
    );
}

export default PageRegistryFuelCards;